import { Link } from 'react-router-dom';
import { ArrowRight, Target, Compass, BookOpen, Home } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-warm-50 grid place-items-center px-6 py-20">
      <div className="text-center max-w-lg">
        <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-500 mb-4">
          404
        </div>
        <h1 className="font-display text-5xl mb-4 leading-tight">
          This page does not exist.
        </h1>
        <p className="text-ink-600 text-lg leading-relaxed mb-10">
          The page you are looking for may have moved or never existed. Here are
          a few places worth going instead.
        </p>
        <div className="grid sm:grid-cols-2 gap-4 text-left">
          <Link
            to="/try"
            className="group bg-white border border-ink-100 rounded-2xl p-5 hover:border-ink-200 hover:shadow-soft transition-all"
          >
            <div className="flex items-center gap-3 mb-1">
              <Target className="w-5 h-5 text-accent-600" />
              <span className="font-display text-lg text-ink-900">Try a challenge</span>
            </div>
            <p className="text-sm text-ink-500 leading-relaxed">
              Complete one full challenge free. Get graded by AI.
            </p>
          </Link>
          <Link
            to="/skill-paths"
            className="group bg-white border border-ink-100 rounded-2xl p-5 hover:border-ink-200 hover:shadow-soft transition-all"
          >
            <div className="flex items-center gap-3 mb-1">
              <Compass className="w-5 h-5 text-accent-600" />
              <span className="font-display text-lg text-ink-900">Browse paths</span>
            </div>
            <p className="text-sm text-ink-500 leading-relaxed">
              Practice paths that target specific AI skills.
            </p>
          </Link>
          <Link
            to="/blog"
            className="group bg-white border border-ink-100 rounded-2xl p-5 hover:border-ink-200 hover:shadow-soft transition-all"
          >
            <div className="flex items-center gap-3 mb-1">
              <BookOpen className="w-5 h-5 text-accent-600" />
              <span className="font-display text-lg text-ink-900">Read the blog</span>
            </div>
            <p className="text-sm text-ink-500 leading-relaxed">
              Field notes on AI skills and daily practice.
            </p>
          </Link>
          <Link
            to="/"
            className="group bg-white border border-ink-100 rounded-2xl p-5 hover:border-ink-200 hover:shadow-soft transition-all"
          >
            <div className="flex items-center gap-3 mb-1">
              <Home className="w-5 h-5 text-accent-600" />
              <span className="font-display text-lg text-ink-900">Go home</span>
            </div>
            <p className="text-sm text-ink-500 leading-relaxed">
              Start from the beginning.
            </p>
          </Link>
        </div>
        <div className="mt-10">
          <Link to="/" className="btn-primary">
            Back to home <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
